import useAsync from 'react-use/esm/useAsync'
import { AgentRequest } from '~/protos/agents'
import { TaskParams } from '../../BaseTaskForm'

interface Mule3ToMule4MigrationFormProps {
  onChange: (task: TaskParams) => void
  flowNames: string | null
  disabled?: boolean
}

export function Mule3ToMule4MigrationForm({
  onChange,
  flowNames,
  disabled
}: Mule3ToMule4MigrationFormProps) {
  useAsync(async () => {
    if (flowNames != null) {
      const request = AgentRequest.fromPartial({
        command: { commandString: flowNames }
      })
      onChange?.({ request })
    }
  }, [flowNames])

  return null
}
